import { readingNeedsConfirm } from '../../shared/reading-confirm.js';
import { effectiveParam } from './params.js';
import { formatSalinity, salinityUnitLabel, formatSalinityRange, endSentence } from './salinity.js';
import { getDisplayUnits, formatTemp } from './units.js';
import { currentReadingsClient } from './utils.js';

// The "Are you sure?" line for a hand-typed reading far outside the
// keeper's range, in the keeper's own units. `value` is in storage units
// (ppt, °F), as it will be saved. null when there is nothing to ask.
// `typed` words the number as the keeper typed it when the field was on
// another scale (Hanna P in ppb), so they recognise what they entered.
export function confirmPromptFor(tank, key, value, { salinityUnit = 'ppt', typed = null } = {}) {
  const p = effectiveParam(tank, key);
  // tank.readings is newest first (Home's param cards read [0] as latest).
  // The keeper's own last test, not a Trident number with no test time.
  const previous =
    currentReadingsClient(
      (tank?.readings || []).filter((r) => r.param === key),
      key
    )[0]?.value ?? null;
  const ask = readingNeedsConfirm(tank, key, value, p?.acceptable, { previous });
  if (!ask) return null;
  const [lo, hi] = ask.band;
  const unit = p?.unit ? ` ${p.unit}` : '';
  let shown;
  let range;
  if (key === 'salinity') {
    const label = salinityUnitLabel(salinityUnit);
    shown = `${formatSalinity(ask.value, salinityUnit)} ${label}`;
    range = formatSalinityRange(lo, hi, salinityUnit);
  } else if (key === 'temp') {
    const t = getDisplayUnits(tank).temp === 'C' ? 'C' : 'F';
    shown = formatTemp(ask.value, t);
    range = `${formatTemp(lo, t, { withUnit: false })}–${formatTemp(hi, t)}`;
  } else {
    shown = typed || `${ask.value}${unit}`;
    range = `${lo}–${hi}${unit}`;
  }
  const name = p?.label || key;
  return `Are you sure ${name} is ${shown}? ${endSentence(`That is well ${ask.direction === 'low' ? 'below' : 'above'} your range of ${range}`)} Check the number and that it is on the right card before you save.`;
}
